import React from 'react';
import { Form } from '@ant-design/compatible';
import { Select, Button } from 'antd';
import { isEmpty } from 'underscore';

import './filterForm.css';

export default function () {
    const { form, driverTabFilters, divisions, driverList, licenseOptions, assetOptions } = this.props;
    const { getFieldDecorator } = form;

    return (
        <Form
            onSubmit={this.handleSubmit}
            layout="vertical"
        >
            <Form.Item label="Driver">
                {getFieldDecorator('driver', {
                    initialValue: driverTabFilters?.driver || null,
                })(
                    <Select
                        mode="multiple"
                        placeholder="Select Driver"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        allowClear
                        showSearch
                        data-testid='divisions-filter_driver-select'
                    >
                        <Select.Option value="all">Any</Select.Option>
                        {driverList && Array.isArray(driverList) && driverList.length && driverList.map((dl) => (
                            <Select.Option
                                key={dl.id}
                                value={dl.id}
                            >
                                {dl.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </Form.Item>
            <Form.Item label="Division">
                {getFieldDecorator('division', {
                    initialValue: driverTabFilters?.division || null,
                })(
                    <Select
                        mode="multiple"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Division"
                        allowClear
                        showSearch
                        data-testid='divisions-filter_division-select'
                    >
                        {!isEmpty(divisions) && divisions.map((item) => (
                            <Select.Option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </Form.Item>
            <Form.Item label="Licence Type">
                {getFieldDecorator('licence_type')(
                    <Select
                        mode="multiple"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Licence Type"
                        allowClear
                        showSearch
                        data-testid='divisions-filter_licence-type-select'
                    >
                        {!isEmpty(licenseOptions) && licenseOptions.map((item) => (
                            <Select.Option
                                key={item.id}
                                value={item.id}
                            >
                                {item.title}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </Form.Item>
            <Form.Item label="Last Asset">
                {getFieldDecorator('last_asset')(
                    <Select
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Last Asset"
                        allowClear
                        showSearch
                        data-testid='divisions-filter_last-asset-select'
                    >
                        {!isEmpty(assetOptions) && assetOptions.map((item) => (
                            <Select.Option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
            </Form.Item>
            <Form.Item label="Status">
                {getFieldDecorator('status')(
                    <Select
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Status"
                        allowClear
                        showSearch
                        data-testid='divisions-filter_status-select'
                    >
                        <Select.Option value="employed">Employed</Select.Option>
                        <Select.Option value="trainee">Trainee</Select.Option>
                        <Select.Option value="contractor">Contractor</Select.Option>
                        <Select.Option value="agency">Agency</Select.Option>
                    </Select>
                )}
            </Form.Item>
            <Form.Item label="Driver Availability">
                {getFieldDecorator('available')(
                    <Select
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Availability"
                        allowClear
                        showSearch
                        data-testid='divisions-filter_availability-select'
                    >
                        <Select.Option value={1}>Available</Select.Option>
                        <Select.Option value={0}>Not Available</Select.Option>
                    </Select>
                )}
            </Form.Item>
            <div className="mt-2 mb-1 text-center">
                <Button
                    htmlType="submit"
                    type="primary"
                    data-testid='divisions-filter_filter-btn'
                >
                    Filter
                </Button>
            </div>
        </Form>
    );
}
